import type { TasteSettings } from '../lib/localPrefs';
import fixture from './recommendations.json';

export type RecommendationSource = 'doc' | 'searches';

export type Recommendation = {
  albumId: string;
  title: string;
  artist: string;
  artistId: string | null;
  year: number;
  cover: string;
  url: string;
  kind: 'album' | 'ep' | 'single';
  source: RecommendationSource;
  reason: string;
};

/**
 * The one seam between the UI and recommendation logic. v1 returns a fixed mock list and
 * ignores taste settings on purpose (FR-T6); a real implementation keeps this signature.
 */
export async function getRecommendations(_taste: TasteSettings): Promise<Recommendation[]> {
  return fixture.recommendations as Recommendation[];
}

/**
 * Synchronous first paint: what the service can return without waiting (the whole mock in v1).
 * A real service returns undefined here and the Home skeleton holds the space instead.
 */
export function peekRecommendations(_taste: TasteSettings): Recommendation[] | undefined {
  return fixture.recommendations as Recommendation[];
}

export type RecFilter = 'all' | RecommendationSource;

/** Albums first; singles/EPs only when asked, and always after the albums (FR-H6). */
export function arrangeRecommendations(
  recs: Recommendation[],
  { filter, hidden, showSinglesEps }: { filter: RecFilter; hidden: string[]; showSinglesEps: boolean },
): { albums: Recommendation[]; singlesEps: Recommendation[] } {
  const visible = recs.filter((r) => !hidden.includes(r.albumId) && (filter === 'all' || r.source === filter));
  return {
    albums: visible.filter((r) => r.kind === 'album'),
    singlesEps: showSinglesEps ? visible.filter((r) => r.kind !== 'album') : [],
  };
}
